// test1651
(1651 && 0);
